import { connect } from "react-redux";

import { Creators } from "../../../../services/redux/vignets/actions";
import VignetteActivation from "./components";

const mapStateToProps = (state) => {
  const { isActivatingCheckVignette, error } = state.vignets;
  return {
    isActivatingCheckVignette,
    error,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    activateVignette: (data) => {
      dispatch(Creators.activateCheckVignette(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VignetteActivation);
